import icon12 from '../../assets/Godrej/footer_reloy_logo.png';
import { winnreAuth } from '../../utils/axios';
import React, { useEffect } from 'react';

const CustomFooter = ({ config }) => {
    const brand = config?.customHomePageTitle;
    const disclaimerContent = {
        Anarock: {
            text: `This is to inform user / customer(s) that www.anarock.com is the only official website of Anarock Group ("Company"). User/Customer(s) are cautioned and advised not to rely upon any information stated on any other websites which may appear to be similar to the Company's official website, including containing Company's logo / brand name. The information contained in such websites may be misleading/false and user/customer(s) may suffer loss if they rely on such information. In the event user/customer(s) come across any such websites similar to Company's official website containing its brand name/logo or any other information, then kindly contact and inform us at info@anarock.com in order to enable the Company to take necessary action.`
        },
        default: {
            text: `This is to inform user / customer(s) that www.godrejproperties.com, www.godrejthetrees.com & www.godrej.com are the only official websites of Godrej Properties Limited ("Company"). User/Customer(s) are cautioned and advised not to rely upon any information stated on any other websites which may appear to be similar to the company's official website, including containing company's logo / brand name. The information contained in such websites may be misleading/false and user/customer(s) may suffer loss if they rely on such information. In the event user/customer(s) come across any such websites similar to company's official website containing its brand name/logo or any other information, then kindly contact and inform us on partnerconnect@godrejproperties.com in order to enable the Company to take necessary action.`
        }
    };
    const contactUsUrls = {
        Anarock: 'https://www.anarock.com/contact-us',
        default: 'https://www.godrejproperties.com/reach-us'
    };
    const [termsUrl, setTermsUrl] = React.useState(false);

    useEffect(() => {
        winnreAuth({
            url: 'winnre/noAuth/about/summary',
            method: 'GET'
        })
            .then((res) => {
                // console.log(res);
                setTermsUrl(res?.termsOfService);
            })
            .catch((err) => {
                // console.log(err);
            });
    }, []);

    return (
        <footer
            className={`${brand === 'Anarock'
                    ? 'bg-gradient-to-r from-[#1D1A55] to-[#9B499B]'
                    : 'bg-[#7F7065]'
                } text-white pb-12`}
        >
            <div className="container mx-auto px-6">
                <div className="w-[90%] mx-auto flex justify-between space-x-4 pt-6 pb-6">
                    <div>
                        <a
                            href={contactUsUrls[brand] || contactUsUrls.default}
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            Contact Us
                        </a>
                    </div>
                    <div>
                        <a
                            href={termsUrl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="cursor-pointer"
                        >
                            Terms and Conditions
                        </a>
                    </div>
                </div>
                <div className="text-center">
                    <h3 className="text-xl font-normal tracking-wide mb-4">
                        DISCLAIMER
                    </h3>
                    <div className="w-[90%] mx-auto text-sm leading-relaxed space-y-4">
                        <p className="text-justify font-normal text-[#f2f1f0] opacity-90">
                            {disclaimerContent[brand]?.text ||
                                disclaimerContent.default.text}
                        </p>

                        <div className="lg:flex justify-center pt-4 space-x-4">
                            <div className="w-full flex items-center lg:w-[8%] mx-auto">
                                <img
                                    src={icon12}
                                    alt="Reloy Logo"
                                    className="h-auto w-[30%] md:w-[16%] pb-2 lg:pb-0 lg:w-[90%] mx-auto"
                                />
                            </div>
                            <div className="text-xs w-full lg:w-[92%] mx-auto leading-relaxed">
                                <p className="text-justify opacity-90">
                                    {`Reloy is run by Loyalie IT-Solutions Pvt. Ltd. This referral program is run by Loyalie IT Solutions Pvt. Ltd. and the referral payout will be processed by them. Loyalie IT Solutions Pvt. Ltd. is registered as a Real Estate Agent under RERA in Maharashtra MAHARERA NO - A51900010267 | Haryana RERA No. - HRERA-PKL-REA-239-2020 | Tamil Nadu RERA NO - TN/Agent/0092/2023 | Karnataka RERA NO-PRM/KA/RERA/1251/309/AG/180524/000935 | West Bengal RERA NO – HIRA/A/KOL/2019/000350 | Uttar Pradesh RERA NO – UPRERAAGT22593 | Gujarat RERA No: AG/GJ/AHMEDABAD/AHMEDABAD CITY/AUDA/AA01891/090327R1 | Delhi RERA Application Reference No: 22-3754-2891 | Goa RERA NO – AGGO02210817 | Telangana RERA NO – A02500001321 | maharera.mahaonline.gov.in | haryanarera.gov.in | www.tnrera.in | rera.karnataka.gov.in | hira.wb.gov.in | up-rera.in | gujrera.gujarat.gov.in | rera.delhi.gov.in | rera.goa.gov.in | rera.telangana.gov.in`}
                                </p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
};

export default CustomFooter;
